<template>
  <div class="modal-dialog is-top is-rounded">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-header__title">充電費率變動</h1>
      </div>
      <div class="modal-body">
        <p>
          目前充電費率調整為
          <strong>{{ currentPrice.unitPrice }}</strong> 每千瓦小時/元。
        </p>
      </div>
      <div class="modal-footer">
        <router-link
          :to="{
            name: 'PlugHint',
            params: {
              connectorId: this.$route.params.connectorId,
              stationId: this.$route.params.stationId,
            },
          }"
          class="button is-fullwidth mb-2 is-fill"
        >
          繼續前往充電
        </router-link>
        <button
          type="button"
          class="button is-fullwidth is-normal"
          @click="handleCancel()"
        >
          返回
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PriceAnnouncementModal.vue",
  props: {
    currentPrice: { type: Object, require: true },
  },
  methods: {
    handleCancel() {
      this.$emit("price-adjust");
    },
  },
};
</script>
